import * as Yup from "yup";

import { VeteranAutoCoverage } from "Store/interfaces/products/coverage";
import { getIsMemberOfVeteranClubSchema } from "../ProductDetails/veteranAutoProductDetailsValidation";
import { VeteranAutoProductPriceFormValues } from "../veteranAutoInterface";

export const getBaseSchema = (): Yup.ObjectSchema<
  Pick<VeteranAutoProductPriceFormValues, "coverage">
> =>
  Yup.object().shape({
    coverage: Yup.mixed<VeteranAutoCoverage>()
      .required()
      .oneOf(Object.values(VeteranAutoCoverage)),
  });

export const validationSchema = (): Yup.ObjectSchema<
  Omit<VeteranAutoProductPriceFormValues, "tfaAmount">
> => getBaseSchema().concat(getIsMemberOfVeteranClubSchema());
